/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-11-17 15:37:50
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-11-17 16:11:56
 * @FilePath: \baishu_react_ui\src\utils\cacheUtils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const CacheUtils = {
    // 存储请求接口地址以及请求体和取消函数之间的映射关系
    cache: {},
    // 根据提供的键名 key 取消对应的请求，若未提供则取消全部请求
    clearCache: function (key) {
        if (key) {
            const cancel = this.cache[key];
            if (cancel && typeof cancel === 'function') {
                cancel();
                console.log('CacheUtils 取消了' + key + '的请求')
                delete this.cache[key];
            }
            return;
        }
        Object.keys(this.cache).forEach(cacheKey => {
            const cancel = this.cache[cacheKey];
            cancel();
            console.log('CacheUtils 取消了' + key + '的请求')
            delete this.cache[cacheKey];
        });
    },
};